export default __webpack_public_path__ + "static/media/ryzen3900xt.c25a39bf.jpg";